export default __webpack_public_path__ + "static/media/spin.709416dd.gif";